import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

const fetchTaxCreditList = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.GET_TAX_CREDIT}?page=1&limit=100`,
  });
  return res;
};
const saveTaxCredit = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_TAX_CREDIT}`,
    body,
  });
  return res;
};
const deleteTaxCredit = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_TAX_CREDIT}?id=${id}`,
  });
  return res;
};

const updateTaxCredit = async (body) => {
  let res = await FETCH.putWithoutId({
    url: `${ROUTES.CREATE_TAX_CREDIT}`,
    body,
  });
  return res;
};
const fetchTaxInflationDetails = async () => {
  let res = await FETCH.get({
    url: ROUTES.GET_TAX_INFLATION,
  });
  return res;
};
const saveTaxInflationDetails = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_TAX_INFLATION}`,
    body,
  });
  return res;
};
const updateTaxInflationDetails = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.CREATE_TAX_INFLATION}`,
    body,
  });
  return res;
};

const fetchCarryForward = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.CREATE_CARRY_FORWARD}?page=1&limit=100`,
  });
  return res;
};
const createCarryForward= async(body)=>{
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_CARRY_FORWARD}`,
    body,
  });
  return res;
}
const updateCarryForward= async(body)=>{
  let res = await FETCH.put2({
    url: `${ROUTES.CREATE_CARRY_FORWARD}`,
    body,
  });
  return res;
}
const deleteCarryForwad = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.CREATE_CARRY_FORWARD}?id=${id}`,
  });
  return res;
};

const fetchCarryForwardTax = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.CREATE_CARRY_FORWARD_Tax}?page=1&limit=100`,
  });
  return res;
};
const createCarryForwardTax= async(body)=>{
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_CARRY_FORWARD_Tax}`,
    body,
  });
  return res;
}
const updateCarryForwardTax= async(body)=>{
  let res = await FETCH.put2({
    url: `${ROUTES.CREATE_CARRY_FORWARD_Tax}`,
    body,
  });
  return res;
}
const deleteCarryForwadTax = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.CREATE_CARRY_FORWARD_Tax}?id=${id}`,
  });
  return res;
};
const getRatesofReturn = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.CREATE_RATE_OF_RETURN}`,
  });
  return res;
};
const getUserDefinedDetails = async () => {
  let res = await FETCH.get({
    url: `${ROUTES.USER_DEFINED_DETAILS}`,
  });
  return res;
};

const createRatesofReturn = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_RATE_OF_RETURN}`,
    body,
  });
  return res;
};
const updateRatesofReturn = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.CREATE_RATE_OF_RETURN}`,
    body,
  });
  return res;
};
const getUserDefined = async (page) => {
  let res = await FETCH.get({
    url: `${ROUTES.USER_DEFINED}?page=${page}&limit=10`,
  });
  return res;
};

const createUserDefined = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.USER_DEFINED}`,
    body,
  });
  return res;
};

const updateUserDefined = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.USER_DEFINED}`,
    body,
  });
  return res;
};
const deleteUserDefined = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.USER_DEFINED}?id=${id}`,
  });
  return res;
};

const TAX_AND_INFLATION_API = {
  fetchTaxCreditList,
  saveTaxCredit,
  fetchTaxInflationDetails,
  saveTaxInflationDetails,
  updateTaxInflationDetails,
  updateTaxCredit,
  deleteTaxCredit,
  fetchCarryForward,
  createCarryForward,
  updateCarryForward,
  deleteCarryForwad,
  fetchCarryForwardTax,
  createCarryForwardTax,
  updateCarryForwardTax,
  deleteCarryForwadTax,
  createRatesofReturn,
  getRatesofReturn,
  getUserDefinedDetails,
  updateRatesofReturn,
  createUserDefined,
  getUserDefined,
  updateUserDefined,
  deleteUserDefined
  
};
export default TAX_AND_INFLATION_API;
